import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Carousel from '../components/carousel';
import IntegrationsGrid from '../components/integrations-grid';
import ItemsGrid from '../components/items-grid';
import SideBySide from '../components/side-by-side';
import SupportTile from '../components/support-tile';
import DialogButton from '../components/dialogButton';

import {
    CloudIcon,
    SupportIcon,
    HumanIcon,
    TrainingIcon,
} from '../components/icons';

const Support = () => {
    const data = useStaticQuery(graphql`
        query {
            map: file(relativePath: { eq: "support-hero.jpeg" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);

    return (
        <Layout>
            <SEO
                title="Support"
                url="/weave-support"
                description="We value our customer service as much as we value our product. It is our top priority to solve any issue quickly. The Weave support team answers your calls when you need help. Our knowledgable support team helped build this product from the ground up and keeps it running smoothly each and every day."
            />
            <SideBySide
                buttonsList={[
                    <DialogButton key="start">Prove It</DialogButton>,
                ]}
                copy={[
                    'We value our customer service as much as we value our product. It is our top priority to solve any issue quickly. ',
                    <br></br>,
                    <br></br>,
                    <p>
                        The Weave support team answers your calls when you need
                        help. Our knowledgable support team helped build this
                        product from the ground up and keeps it running smoothly
                        each and every day.
                    </p>,
                ]}
                image={data.map.childImageSharp.fluid}
                imagePosition="right"
                sideHeader="Weave Support"
            />
            <ItemsGrid>
                <SupportTile
                    copy="Weave is built on reliable Google Cloud infrastructure with 99.9% uptime and critical accuracy. We experience near zero downtime giving you the confidence that your most critical systems are operational."
                    icon={<CloudIcon />}
                    header="99% Uptime"
                />
                <SupportTile
                    copy="Call us, email us, or send us a carrier pigeon. We take pride in being available on whatever form of communication works best for you, and whenever works best for you. Our team will deliver world-class support - guaranteed."
                    icon={<SupportIcon />}
                    header="24/7 Support"
                />
                <SupportTile
                    copy="If you have an issue with one of your most critical systems, you want to speak to a person, not a bot. All of our customer support is handled by 100% certified genuine human beings that know what they're talking about.  "
                    icon={<HumanIcon />}
                    header="Real Humans"
                />
                <SupportTile
                    copy="Train your employees on Weave in a matter of hours. We offer comprehensive training materials for each aspect of Weave, and update our library whenever a new feature is released."
                    icon={<TrainingIcon />}
                    header="Training Materials"
                />
            </ItemsGrid>
            <Carousel
                // buttonsList={[<button key="one">I don't know what this button should do</button>]}
                copy="Find out what our customers are saying about us."
                header="Customer Testimonials"
            />
            <IntegrationsGrid
                copy="We understand we can't do it all. By partnering with the best in the industry, we make sure you and your customers have a seamless end to end experience."
                header="Our Partners"
            />
        </Layout>
    );
};

export default Support;
